export default __webpack_public_path__ + "static/media/product-1.7774ca27.jpg";